import React from 'react';
import { DEFAULT_USER_AVATAR, SENSITIVE_USER_AVATAR } from '../utils/avatarAssets';
import { framePhotoStyle, frameArtworkStyle, responsiveFrameArtworkStyle } from '../utils/frameFit';
import './FramedAvatar.css';

// Keep frames as native images: animated GIF/WebP must never pass through canvas.
export default function FramedAvatar({ src, alt = '', frameUrl, frameBorderRadius, frameFit, size = 40, portraitSize, sensitive = false, fitPreview = false }) {
  const [failedFrame, setFailedFrame] = React.useState(null);
  const [failedImage, setFailedImage] = React.useState(null);
  const framed = Boolean(frameUrl && failedFrame !== frameUrl);
  const fixedPortrait = Number.isFinite(portraitSize) && portraitSize > 0;
  const radius = framed ? frameBorderRadius || '10%' : '50%';
  const photoStyle = fitPreview ? framePhotoStyle(framed ? frameFit : { inset: 0 }, radius)
    : { position:'absolute', left:'1px', top:'1px', width:'calc(100% - 2px)', height:'calc(100% - 2px)', borderRadius:radius, transform:'none', boxSizing:'border-box' };
  // Mixing inset with left/top causes React updates to reset unchanged offsets.
  delete photoStyle.inset;
  photoStyle.right = 'auto'; photoStyle.bottom = 'auto';
  if (fixedPortrait) Object.assign(photoStyle, {
    left: `calc(50% - ${portraitSize / 2}px)`, top: `calc(50% - ${portraitSize / 2}px)`,
    width: portraitSize, height: portraitSize,
  });
  const artworkStyle = fixedPortrait ? frameArtworkStyle(frameFit, portraitSize) : fitPreview ? {} : responsiveFrameArtworkStyle(frameFit);
  return <span className="framed-avatar" style={{ position: 'relative', display: 'inline-block', flexShrink: 0, verticalAlign: 'middle', width: size, height: size, overflow: 'visible', isolation:'isolate' }}>
    <img alt={alt} src={sensitive ? SENSITIVE_USER_AVATAR : !src || failedImage === src ? DEFAULT_USER_AVATAR : src}
      style={{ display: 'block', objectFit: 'cover', border:0, padding:0, background:'transparent', maxWidth:'none', ...photoStyle }}
      onError={() => { if (!sensitive && src && failedImage !== src) setFailedImage(src); }} />
    {framed && <img src={frameUrl} alt="" aria-hidden="true" onError={() => setFailedFrame(frameUrl)}
      style={{ position: 'absolute', display: 'block', left:0, top:0, right:'auto', bottom:'auto', width: '100%', height: '100%', maxWidth:'none', border:0, padding:0, background:'transparent', borderRadius:0, objectFit: 'contain', pointerEvents: 'none', ...artworkStyle }} />}
  </span>;
}
